module.exports = "\n\n"


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/src/app/pre-loader/pre-loader.component.html
// module id = ../../../../../src/app/pre-loader/pre-loader.component.html
// module chunks = 0